import React from 'react';
import './sec3-about.css'
import { useEffect } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
import { useRef } from 'react';
import Cardabout from '../components/common/card-about';
import pic50 from'../assets/pic50.png'



const Sec3about = (props) => {


 const [headers, setheaders]= useState([]);

useEffect(() => {
const getheaders = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
setheaders(res.data);
}
getheaders();
}, []);



const [dates, setDates] = useState([]);
const [timetable, setTimetable] = useState([]);
const [filteredData, setFilteredData] = useState([]);
const [open, setOpen] = useState(false);
const [selected, setSelected] = useState("");



useEffect(() => {
  const fetchTimetable = async () => {
    const { data, error } = await supabase
      .from("timetable_section_repeated_sections")
      .select("*")
      .eq("exbition_id", 1)
      .order("date", { ascending: true });

    if (error) {
      console.error(error);
      return;
    }

    setTimetable(data);

    const uniqueDates = [...new Set(data.map(item => item.date))];
    setDates(uniqueDates);

    if (uniqueDates.length > 0) {
      setSelected(uniqueDates[0]);

      const firstFiltered = data.filter(
        item => item.date === uniqueDates[0]
      );
      setFilteredData(firstFiltered);
    }
  };

  fetchTimetable();
}, []);




const handleSelect = (date) => {
  setSelected(date);
  setOpen(false);

  const filtered = timetable.filter(item => item.date === date);
  setFilteredData(filtered);
};




 const secRef = useRef(null);


useEffect(() => {


  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, []);






    return ( 
        <section className='sec3-about' ref={secRef}>
            <section className='container-sec3-about'>
                <article className='part1-sec4-about'>
                    <h1 className='header-sec4-about'>{headers?.[19]?.header}</h1>
                    




                        <div className='dropdownn-aboutt'>

                            <div  className="search-wrapper2">
                                
                            <div className="filter-input2" tabIndex={0} onClick={() => setOpen(!open)}>

                            <span className={selected ? "selected-text" : "placeholder"}>
                            {selected
                                ? new Date(selected).toLocaleDateString()
                                : "Select Date"}
                            </span>

                            <span className="dropdown-icon2">
                            <img src={pic50} alt='dropdown' />
                            </span>
                            </div>




                        {open && (
                        <div className="dropdown-menu2">
                            {dates.map((date, index) => (
                            <div
                                key={index}
                                className="dropdown-item2"
                                onClick={() => handleSelect(date)}
                            >
                                {date}
                            </div>
                            ))}

                        </div>
                        )}

                            </div>

                        </div>

                </article>



                            <article className='container-cards-sec3-about'>
                                {filteredData.map((item) => (
                                <Cardabout
                                key={item.id}
                                date={`${item.start_time} - ${item.end_time}`}
                                task={item.sentence}
                                />
                            ))}
                            </article>




            </section>
        </section>
     );
}
 
export default Sec3about;